import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.widget.ticketing');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-widget-ticketing',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.widget.ticketing/view.scss */
/* src/app/portal.gsdcuser.widget.ticketing/view.scss: no such file or directory */`],
})
export class PortalGsdcuserWidgetTicketingComponent implements OnInit {

    public ticketing: any = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return;
        this.ticketing = data;
        await this.service.render();
    }
}

export default PortalGsdcuserWidgetTicketingComponent;